module.exports = __webpack_public_path__ + "static/media/payment_description.d46c35eb.svg";